import { createAction, props } from '@ngrx/store';

export const fetchGuides = createAction('[StateGuides/API] Fetch Guides');

export const updateGuides = createAction('[StateGuides/API] Update Guides', props<any>());

export const fetchDegreeGuides = createAction(
	'[StateGuides/API] Fetch Subject Degree Guides',
);

export const updateDegreeGuides = createAction(
	'[StateGuides/API] Update Subject Degree Guides',
	props<any>(),
);

export const fetchCityGuides = createAction(
	'[StateGuides/API] Fetch Student City Guides',
);

export const updateCityGuides = createAction(
	'[StateGuides/API] Update Student City Guides',
	props<any>(),
);

export const fetchCareerGuides = createAction(
	'[StateGuides/API] Fetch Student Career Guides',
);

export const updateCareerGuides = createAction(
	'[StateGuides/API] Update Student Career Guides',
	props<any>(),
);

export const loadStateGuidesFailure = createAction(
	'[StateGuides/API] Load StateGuides Failure',
	props<any>(),
);

export const fetchSingleGuide = createAction(
	'[StateGuides/API] Fetch Single Guide',
	props<any>(),
);

export const updateSingleGuide = createAction(
	'[StateGuides/API] Update Single Guide',
	props<{ singleGuide: any }>(),
);
